__webpack_require__.p = "/_ui/epresponsive/theme-ep/build/js/fr_CH/";